<template>
  <div id="cancel-modal-preview" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="p-5 text-center">
            <XCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
            <div class="text-3xl mt-5">
              คุณแน่ใจ
            </div>
            <div class="text-gray-600 mt-2">
              ต้องการยกเลิกรายการนี้ ใช่ หรือ ไม่?
            </div>
            <div class="mt-4 text-left">
              <label for="" class="form-label text-lg"
                >เหตุผลในการยกเลิก:</label
              >
              <textarea
                name=""
                class="form-control"
                rows="5"
                v-model="reason"
                placeholder="เพิ่มเติม..."
              ></textarea>
            </div>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1"
            >
              ไม่
            </button>
            <button
              type="button"
              class="btn btn-danger w-24"
              data-dismiss="modal"
              @click="cancel()"
            >
              ใช่
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import { api } from '../utils/api'
import alert from '../helpers/alert'

export default defineComponent({
  name: 'modalCancel',
  props: {
    module: {
      type: String,
      required: true
    },
    docType: {
      type: String,
      required: true
    },
    docId: {
      type: [Number, String]
    },
    redirectComplete: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const router = useRouter()
    const reason = ref(null)
    const cancel = async () => {
      if (reason.value === null) {
        alert.error('กรอกเหตุผลในการยกเลิก')
        return false
      }
      await api
        .put(`/${props.module}/${props.docType}/cancel/${props.docId}`, {
          reason: reason.value
        })
        .then(res => {
          if (res.code == 200) {
            // cash('#cancel-modal-preview').modal('hide')
            router.push({ name: props.redirectComplete })
          } else {
            alert.error(res.message)
          }
        })
        .catch(e => alert.error(e.message))
    }

    return {
      cancel,
      reason
    }
  }
})
</script>

<style scoped></style>
